import { getTrimmedLabel } from '@helpers/getTrimmedLabel'
import { Badge, Spreader } from '@ui-kit'
import { Row } from 'simple-flexbox'

export const ON = 'on'
export const OFF = 'off'

export const removeLabelFromCheckboxValue = (value: string) => {
  if (value === ON || value === OFF) {
    return value
  }

  if (value.startsWith(`(${ON})`)) {
    return ON
  }

  if (value.startsWith(`(${OFF})`)) {
    return OFF
  }

  return ''
}

export const removeOnOffFromCheckboxValue = (value: string) => {
  if (value.startsWith(`(${ON})`)) {
    return value.replace(`(${ON}) `, '')
  }

  if (value.startsWith(`(${OFF})`)) {
    return value.replace(`(${OFF}) `, '')
  }

  return ''
}

export const Checkbox = ({
  value,
  label,
  size = 12
}: {
  value: string
  label: string
  size?: 10 | 12
}) => {
  if (value === '-') {
    return '-'
  }

  const { trimmedLabel } = getTrimmedLabel({
    label,
    maxNumberOfCharacters: 10
  })

  const normalizedValue = removeLabelFromCheckboxValue(value)

  const isValueOn = normalizedValue === ON

  return (
    <Row>
      <Badge
        variant={isValueOn ? 'success-filled' : 'error-filled'}
        radius={250}
        icon={isValueOn ? 'icon-ok' : 'icon-remove'}
        isTextUppercase
        size={size}
        hasCursorPointer
      >
        {normalizedValue}
      </Badge>

      <Spreader spread={5} />

      {trimmedLabel}
    </Row>
  )
}
